export const PAY_NOW_STRINGS = {
  title: 'Balances',
  'pay_now.button': 'Confirm Payment',
  'pay_now.total': 'Total',
  'pay_now.no_balances': 'No payable balances found.',
  'pay_now.select_balances': 'Select the balances you want to pay:',
  'payment.success': 'Payment confirmed',
  'payment.error': 'Something went wrong. Please try again.',
  'payment_methods.title': 'Payment Methods',
};
